<script>
    import {claimables, drops, cleanAddress, state, pastDrops as pastDrops_injected} from "../stores/contracts";
    import DropListing from "../components/DropListing.svelte";
    import Window from "../components/Window.svelte";
    import {pastDrops as pastDrops_infura, state_infura, useInfura} from "../stores/contracts-infura";

    export let depth;
    export let toFront = ()=>{};
    export let minimise = ()=>{};
    export let openDrop = ()=>{};
    export let active;

    let dropList = [];
    let _state;


    $:{
        if ($useInfura) {
            _state = $state_infura;
        } else {
            _state = $state;
        }


        dropList = [];
        for (let tokenAddress in $claimables) {
            tokenAddress = cleanAddress(tokenAddress);
            for (let dropTokenId in $claimables[tokenAddress]) {
                if (
                    $claimables[tokenAddress][dropTokenId].length > 0
                    &&
                    $drops[tokenAddress]
                    &&
                    $drops[tokenAddress][dropTokenId]
                ) {
                    dropList.push({
                        tokenAddress,
                        dropTokenId,
                        atomicNumber: $drops[tokenAddress][dropTokenId].atomicNumber,
                        ionCharge: $drops[tokenAddress][dropTokenId].ionCharge,
                        isIon: $drops[tokenAddress][dropTokenId].isIon,
                        tokenId: $drops[tokenAddress][dropTokenId].tokenId,
                        blockNumber: $drops[tokenAddress][dropTokenId].blockNumber,
                        probability: $drops[tokenAddress][dropTokenId].probability
                    });
                }
            }
        }
    }
</script>

<style>
    h1{
        text-align: center;
        font-size: 30px;
        font-weight: 700;

        margin-bottom:20px;
    }
    .section-drops{
        display: flex;
        flex-direction: row;
        width:100%;
        flex-wrap: wrap;
        justify-content: center;
        align-content: flex-start;
        align-items: flex-start;
        gap: 34px 54px ;
    }

    .section-loading{
        font-size: 30px;
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .section-loading div{
        padding-top: 50px;
    }
    .error{
        color: darkred;
    }
</style>

<Window depth={depth} toFront={toFront} active={active} name="CLAIMABLE"  minimise={minimise}>

    <h1>Drops you can claim</h1>
    {#if _state !== "loaded"}
        {#if _state === "network"}
            <div class="section-loading error">
                <div>Please connect to Ethereum mainnet.</div>
            </div>
        {:else if _state === "error"}
            <div class="section-loading  error">
                <div >Web3 connection error.</div>
            </div>
        {:else }
            <div class="section-loading">
                <div >Loading data...</div>
            </div>
        {/if}


    {:else}
        <div class="section-drops">
            {#each dropList as drop}
                <DropListing  drop={drop} openDrop={openDrop}/>
            {/each}
        </div>
    {/if}

</Window>
